import type { RunId } from "../types";

export class RunSuspendedError extends Error {
  constructor(
    readonly runId: RunId,
    readonly taskId: string,
  ) {
    super(`RunSuspendedError: run ${runId} suspended on task ${taskId}`);
    this.name = "RunSuspendedError";
  }
}
